import { IRestaurantProductsTable } from "../interfaces";
import { FETCH_SUCCESS, TABLE_UPDATE } from "../types";
import { MANAGE_TABLE } from "app/ManageTables/types";
import { tableResponse, tableUpdate } from "helpers/reducers";
import { AnyAction } from "redux";

function RestaurantProductsTable(
    state: IRestaurantProductsTable = {
        id: "RestaurantProductsTable",
        idKey: "id",
        columns: [],
        availableColumns: [],
        elasticSearch: true,
        filters: {},
        filterData: [],
        filterSettings: {
            open: false,
            total: 0,
        },
        pagination: {
            page: 1,
            per_page: 20,
            isLastPage: true,
            total: 0,
        },
        search: "",
        selection: {
            id: "id",
            selected: [],
        },
        selectionActions: null,
        sort: { name: "asc" },
        with: [],
        withCount: [],
    },
    action: AnyAction
) {
    switch (action.type) {
        case FETCH_SUCCESS:
            if (action.response.config.params._table_id === state.id) {
                return tableResponse(state, action);
            }
            return state;

        case MANAGE_TABLE:
            if (action.data.id === state.id) {
                return {
                    ...state,
                    ...action.data,
                };
            }
            return state;

        case TABLE_UPDATE:
            return tableUpdate(state, action);
        default:
            return state;
    }
}

export default RestaurantProductsTable;
